// import hooks
import { useState } from "react";
import useMediaQuery from "../../../hooks/useMediaQuery/index.js";
import useEventListener from "../../../hooks/useEventListener/index.js";
import navigationRailStore from "../../../client-store/navigationRail.store.js";
import { isNavigationRailItemSelected } from "./NavigationRail.utils.js";
const WAIT_BEFORE_CLOSING_SUBMENU = 250;
export const useNavigationRail = ({ data, onItemClick, disablePin, selectedId, withPinSwitch, }) => {
    const isLargeScreen = useMediaQuery(({ breakpoints }) => breakpoints.up("large"));
    const currentSubmenu = data.find((item) => isNavigationRailItemSelected(item, selectedId))?.submenu ?? null;
    const setHasPin = (hasPin) => {
        if (!withPinSwitch)
            return;
        navigationRailStore.setHasPinSwitch(hasPin, isLargeScreen);
    };
    if (!isLargeScreen && navigationRailStore.pinSwitch)
        setHasPin(false);
    if (!navigationRailStore.pinSwitch && !withPinSwitch)
        navigationRailStore.setHasPinSwitch(true, isLargeScreen);
    const setPinned = (pinned) => {
        if (disablePin)
            return;
        if (pinned && !isLargeScreen) {
            navigationRailStore.setIsPinned(false);
            return;
        }
        navigationRailStore.setIsPinned(pinned);
    };
    const initSelectedSubmenuState = () => {
        if (isLargeScreen && !disablePin && currentSubmenu?.length) {
            setPinned(true);
            return currentSubmenu;
        }
        return null;
    };
    const [selectedSubmenu, setSelectedSubmenu] = useState(initSelectedSubmenuState);
    const onMouseOverHandler = (item) => {
        setSelectedSubmenu(item.submenu ?? null);
    };
    const onTouchEndHandler = () => {
        if (navigationRailStore.pinSwitch)
            setTimeout(() => setSelectedSubmenu(null), WAIT_BEFORE_CLOSING_SUBMENU);
    };
    const onItemClickHandler = (item) => {
        const foundSubmenu = data.find(({ submenu }) => submenu?.find((submenuItem) => submenuItem.id === item.id ||
            submenuItem.submenu?.find(({ id: nestedSubmenuId }) => nestedSubmenuId === item.id)))?.submenu;
        const newSubmenu = (item.submenu || foundSubmenu) ?? null;
        if (newSubmenu) {
            setPinned(true);
        }
        else {
            setPinned(false);
        }
        setSelectedSubmenu(newSubmenu);
        onItemClick?.(item);
    };
    const resetSubmenuState = () => {
        if (isLargeScreen && !disablePin) {
            setPinned(!!currentSubmenu);
            setSelectedSubmenu(currentSubmenu);
        }
        else {
            setPinned(false);
            setSelectedSubmenu(null);
        }
    };
    useEventListener({
        eventName: "resize",
        payload: resetSubmenuState,
    });
    return {
        selectedSubmenu,
        onItemClickHandler,
        onMouseOverHandler,
        onTouchEndHandler,
        isExpanded: !!selectedSubmenu?.length,
        closeSubmenuHandler: resetSubmenuState,
        showPinSwitch: isLargeScreen && !!currentSubmenu && withPinSwitch,
    };
};
export default useNavigationRail;
